import axios from "axios";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { CustomerDocumentListModel } from "./model";

export const getDocuments = async (): Promise<CustomerDocumentListModel[]> => {
    const response = await axios.get<ServerModelWithDateStrings<CustomerDocumentListModel>[]>("/api/customerDocument");
    return response.data.map(parseCustomerDocument);
};

const parseCustomerDocument = (serverModel: ServerModelWithDateStrings<CustomerDocumentListModel>): CustomerDocumentListModel => ({
    ...serverModel,
    dateCreated: new Date(serverModel.dateCreated)
});
